import { service } from '@/ajax/request';

export const getMessageList = (params: any) => (
    service({
        url: '/wx-public/messageManagePage',
        method: 'POST',
        params,
    })
)

export const updateMessageStatus = (params: any) => (
    service({
        url: '/wx-public/updateStatus',
        method: 'POST',
        params,
    })
)

export const saveOrUpdateMessage = (params: any) => (
    service({
        url: '/wx-public/saveOrUpdate',
        method: 'POST',
        params,
    })
)